(() => {
    const imagesAttributes = document.getElementsByClassName('product-gallery__media');
    const popup = document.querySelector('.popup-main');
    let thumbnailGallery = [];
    const closeBtn = document.querySelector('.btn-close-main');
    const largePreview = document.querySelector('.image-preview-main');
    const largeImage = document.querySelector('.large-image-main');
    const leftArrowMob = document.querySelector('.left-arrow-zoom-main');
    const rightArrowMob = document.querySelector('.right-arrow-zoom-main');
    const leftArrow = document.querySelector('.left-arrow-main');
    const rightArrow = document.querySelector('.right-arrow-main');
    const minusBtn = document.querySelector('.minus-zoom-main');
    const plusBtn = document.querySelector('.plus-zoom-main');
    const canvasZoom = document.querySelector('.canvasZoom');
    const mediaWrapperZoom = document.getElementsByClassName('product-gallery__zoom');
    var imageGalleryMobile = '';
    const thumbnailImageContainer = document.getElementsByClassName('thumbnails-image-main')[0];
    let imagesGalleryMain = null;
    let bodyTemplate = document.getElementsByTagName('body');
    let actualImage = null;
    let actualAttribute = '';
    let imagesVariants = [];
    var window_width = null;
    let srcImageActual = '';
    let index = 0;
    let scale = 1;
    let counter = 1;
    const zoom = {
        min: 1,
        max: 5,
        value: 1,
        step: 0.05
    };
    let x, y;
    let resetTimeout;
    const buttonLeft = [leftArrowMob, leftArrow];
    const buttonRight = [rightArrowMob, rightArrow];

    const totalVariants = document.getElementById('total_variants');
    widthActual();

    if (!totalVariants) return;

    if (parseInt(totalVariants.value) == 1) {
        imageGalleryMobile = document.getElementsByClassName('product-gallery__media-list');

        if (window_width < 1150) {
            imageGalleryMobile[0].addEventListener('click', () => {
                getActualImage().then((img) => {
                    let imgActual = img.getElementsByClassName('rounded')[0];
                    let image_src = imgActual.getAttribute('src');
                    let dataPostion = img.getAttribute('data-position');

                    let pos = parseInt(dataPostion);
                    actualAttribute = imgActual.getAttribute('alt');

                    largeImage.src = `${image_src}`;
                    popup.classList.toggle('active');
                    getImagesVariants(actualAttribute, pos);
                });
            });
        }

    } else {
        setTimeout(() => {
            if (window_width < 1150) {
                getElementsProductGallery().then((element) => {
                    if (!element) return;
                    imageGalleryMobile = element;

                    imageGalleryMobile.addEventListener('click', () => {
                        getActualImage().then((img) => {
                            let imgActual = img.getElementsByClassName('rounded')[0];
                            let image_src = imgActual.getAttribute('src');
                            let dataPostion = img.getAttribute('data-position');

                            let pos = parseInt(dataPostion);
                            actualAttribute = imgActual.getAttribute('alt');

                            largeImage.src = `${image_src}`;
                            popup.classList.toggle('active');
                            getImagesVariants(actualAttribute, pos);
                        });
                    });
                })
            }
        }, 500);
    }



    function popupVisibility() {
        if (window_width < 1150) {
            mediaWrapperZoom[0].addEventListener('click', (event) => {
                event.preventDefault();
                bodyTemplate[0].style.overflow = 'hidden';

                getActualImage().then((img) => {
                    let imgActual = img.getElementsByClassName('rounded')[0];
                    let image_src = imgActual.getAttribute('src');
                    let dataPostion = img.getAttribute('data-position');

                    let pos = parseInt(dataPostion);
                    actualAttribute = imgActual.getAttribute('alt');

                    largeImage.src = `${image_src}`;
                    popup.classList.toggle('active');
                    getImagesVariants(actualAttribute, pos);
                }).then(() => {
                    getThumbnail().then(galleryThumbnail => {
                        for (let x = 0; x < galleryThumbnail.length; x++) {
                            galleryThumbnail[0].classList.add('active');

                            let image = thumbnailGallery[x].getElementsByClassName('rounded')[0].src;
                            const newImage = document.createElement("img");
                            newImage.src = image;
                            newImage.classList.add('img-thumb');

                            if (x == 0) newImage.classList.add('active');

                            thumbnailImageContainer.appendChild(newImage);

                            newImage.addEventListener('click', (event) => {
                                updateImage(x);
                                index = x;

                                activeThumbnail().then(() => {
                                    newImage.classList.add('active');

                                    watchActiveArrows();
                                });
                            })
                        }
                    });
                });
            });
        }
    }

    const getThumbnail = () => {
        return new Promise((resolve, reject) => {
            for (var i = 0; i < imagesAttributes.length; i++) {
                if (imagesAttributes[i].classList.contains('ivariant')) thumbnailGallery.push(imagesAttributes[i]);

                resolve(thumbnailGallery);
            }
        });
    };

    const cleanThumbnail = () => {
        while (thumbnailImageContainer.firstChild) {
            thumbnailImageContainer.removeChild(thumbnailImageContainer.firstChild);
        }
    };

    const activeThumbnail = () => {
        return new Promise((resolve, reject) => {
            let galleryThumbnail = thumbnailImageContainer.getElementsByClassName('img-thumb');

            for (let x = 0; x < galleryThumbnail.length; x++) {
                if (galleryThumbnail[x].classList.contains('active')) {
                    galleryThumbnail[x].classList.remove('active');
                    resolve();
                }
            }
        });
    };

    const swipeThumbnail = (i) => {
        index = i;

        activeThumbnail().then(() => {
            let galleryThumbnail = thumbnailImageContainer.getElementsByClassName('img-thumb');
            galleryThumbnail[i].classList.add('active');
        });
    }

    function getImagesVariants(variant_name, position) {
        let imgActual = '';

        for (var i = 0; i < imagesAttributes.length; i++) {
            if (window_width < 1000) {
                let imgActualContainer = imagesAttributes[i];
                imgActual = imgActualContainer.getElementsByClassName('rounded')[0];

            } else {
                imgActual = imagesAttributes[i].getElementsByClassName('rounded')[0];
            }

            if (imgActual.getAttribute('alt') == variant_name) {
                imagesVariants.push(imgActual);
            }
        }
    };

    const updateImage = (i) => {
        largeImage.src = `${imagesVariants[i].src}`;
        index = i;
        resetZoom();
    }

    if (closeBtn) {
        closeBtn.addEventListener('click', () => {
            popup.classList.toggle('active');
            bodyTemplate[0].style.overflow = '';
            index = 0;
            thumbnailGallery = [];
            cleanThumbnail();
        });
    }


    if (buttonLeft && buttonRight) {
        buttonLeft.map(btn => {
            btn.addEventListener('click', () => {
                activeArrows(event.target.parentElement, 0);

                if (index > 0) {
                    updateImage(index - 1);
                    swipeThumbnail(index);
                }
            });
        });

        buttonRight.map(btn => {
            btn.addEventListener('click', () => {
                activeArrows(event.target.parentElement, 1);
                if (index < imagesVariants.length - 1) {
                    updateImage(index + 1);
                    swipeThumbnail(index);
                }
            });
        });
    }

    if (minusBtn && plusBtn) {
        minusBtn.addEventListener('click', (event) => {
            if (counter > 1) {
                counter = counter - 1;
                largeImage.style.transform = `scale(${counter})`;
            }
        });

        plusBtn.addEventListener('click', (event) => {
            if (counter <= 8) {
                counter = counter + 1;
                largeImage.style.transform = `scale(${counter})`;
                largeImage.style.transformOrigin = '50%' + ' ' + '50%';
            }
        });
    }

    largePreview.addEventListener('wheel', (event) => {
        event.preventDefault();
        zoomWheelPointer(event);
    });

    largePreview.addEventListener('mousemove', e => {
        x = e.clientX - largePreview.offsetLeft;
        y = e.clientY - largePreview.offsetTop;
    });

    largePreview.addEventListener('mouseleave', e => {
        resetZoom();
        counter = 1;
        const zoom = {
            min: 1,
            max: 5,
            value: 1,
            step: 0.05
        };
        x, y;

        largeImage.style.transform = 'scale(1)';
        largeImage.style.transformOrigin = '50%' + ' ' + '50%';
        largeImage.style.transitionDuration = '1s';
    });

    const watchActiveArrows = () => {
        let indexlImagesVariants = imagesVariants.length - 1;
        buttonLeft.map(btn => index == 0 ? btn.disabled = true : btn.disabled = false);
        buttonRight.map(btn => index == indexlImagesVariants ? btn.disabled = true : btn.disabled = false);
    };

    const activeArrows = (btn, dir) => {
        let indexlImagesVariants = imagesVariants.length - 1;
        let newIndex = index + 1;

        if (dir == 1) {
            buttonLeft.map(btn => newIndex != 0 ? btn.disabled = false : btn.disabled = true);
            buttonRight.map(btn => newIndex == indexlImagesVariants ? btn.disabled = true : btn.disabled = false);

        } else {
            buttonLeft.map(btn => index == 1 ? btn.disabled = true : btn.disabled = false);
            buttonRight.map(btn => newIndex <= imagesVariants.length ? btn.disabled = false : btn.disabled = true);
        }
    };

    const zoomWheelPointer = (event) => {
        const elemento = largeImage;
        const factorZoom = 0.1;

        elemento.addEventListener('wheel', (event) => {
            event.preventDefault();

            if (event.deltaY < 0) {
                zoom.value = zoom.value >= zoom.max ? zoom.max : zoom.value + zoom.step;

            } else if (event.deltaY > 0) {
                zoom.value = zoom.value <= zoom.min ? zoom.min : zoom.value - zoom.step;
            }

            largeImage.style.transform = `scale(${zoom.value})`
            var xPerc = (x * 50) / largeImage.width;
            var yPerc = (y * 50) / largeImage.height;
            largeImage.style.transformOrigin = xPerc + '%' + ' ' + yPerc + '%';
        });
    };

    const resetZoom = () => {
        largeImage.style.transform = `scale(1)`;
        largeImage.style.transitionDuration = '1.5s';
    }

    function widthActual() {
        window_width = window.innerWidth;
    }

    function getElementsProductGallery() {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                let productGalleryMediaListElements = document.getElementsByClassName('product-gallery__media-list-wrapper');
                let element = productGalleryMediaListElements[1];
                resolve(element);
            }, 1000);
        });
    }

    document.addEventListener("DOMContentLoaded", (ev) => {
        widthActual();
        if (window_width > 1200) {
            largePreview.classList.add('v-desktop');
            largeImage.classList.add('v-desktop');
            canvasZoom.classList.add('v-desktop');
        } else {
            largePreview.classList.add('v-mobile');
            largeImage.classList.add('v-mobile');
            canvasZoom.classList.add('v-mobile');
        }

        imagesGalleryMain = document.getElementsByClassName('pz-Media');

        document.querySelectorAll(".pz-Media img:not(.pz-Image)").forEach(element => {
            pinchZoom(element);
        });
    });

    const pinchZoom = (imageElement) => {
        let imageElementScale = 1;

        let start = {};

        const distance = (event) => {
            return Math.hypot(event.touches[0].pageX - event.touches[1].pageX, event.touches[0].pageY - event.touches[1].pageY);
        };


        imageElement.addEventListener('touchstart', (event) => {
            imageGalleryMobile[0].classList.add('touch');

            if (event.touches.length === 2) {
                event.preventDefault();

                start.x = (event.touches[0].pageX + event.touches[1].pageX) / 2;
                start.y = (event.touches[0].pageY + event.touches[1].pageY) / 2;
                start.distance = distance(event);

            } else if (event.touches.length == 1) {
                if (imageGalleryMobile[0].classList.contains('touch')) {
                    imageGalleryMobile[0].classList.remove('touch');
                }
            }
        });

        imageElement.addEventListener('touchmove', (event) => {
            if (event.touches.length === 2) {
                event.preventDefault();

                let scale;
                if (event.scale) {
                    scale = event.scale;
                } else {
                    const deltaDistance = distance(event);
                    scale = deltaDistance / start.distance;
                }

                imageElementScale = Math.min(Math.max(1, scale), 4);

                const deltaX = (((event.touches[0].pageX + event.touches[1].pageX) / 2) - start.x) * 2;
                const deltaY = (((event.touches[0].pageY + event.touches[1].pageY) / 2) - start.y) * 2;

                const transform = `translate3d(${deltaX}px, ${deltaY}px, 0) scale(${imageElementScale})`;
                imageElement.style.transform = transform;
                imageElement.style.WebkitTransform = transform;
                imageElement.style.zIndex = "9999";
            }
        });

        imageElement.addEventListener('touchend', (event) => {
            if (imageGalleryMobile[0].classList.contains('touch')) {
                imageGalleryMobile[0].classList.remove('touch');
            }

            imageElement.style.transform = "";
            imageElement.style.WebkitTransform = "";
            imageElement.style.zIndex = "";
        });
    }

    function getActualImage() {
        return new Promise((resolve, reject) => {
            for (var i = 0; i < imagesAttributes.length; i++) {
                imagesAttributes[i].classList.add("clase-agregada");

                if (imagesAttributes[i].classList.contains('is-selected')) {
                    actualImage = imagesAttributes[i];
                    resolve(actualImage);
                }
            }
        });
    };

    if (window_width <= 1200) {
        var angleScale = {
            angle: 0,
            scale: 1
        }

        interact(largePreview)
            .gesturable({
                listeners: {
                    start(event) {
                        angleScale.angle -= event.angle

                        clearTimeout(resetTimeout)
                        largeImage.classList.remove('reset')
                    },
                    move(event) {
                        var currentAngle = event.angle + angleScale.angle;
                        var currentScale = event.scale * angleScale.scale;
                        largeImage.style.transform = 'scale(' + currentScale + ')';
                        dragMoveListener(event)
                    },
                    end(event) {
                        angleScale.angle = angleScale.angle + event.angle;
                        angleScale.scale = angleScale.scale * event.scale;
                        resetTimeout = setTimeout(reset, 2500);
                    }
                }
            }).draggable({
                autoScroll: true,
                inertia: true,
                modifiers: [
                    interact.modifiers.restrictRect({
                        restriction: 'parent',
                        endOnly: true
                    })
                ],
                listeners: {
                    move: dragMoveListener
                }
            });
    }

    function dragMoveListener(event) {
        var target = event.target;
        var x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
        var y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;
        target.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
        target.setAttribute('data-x', x);
        target.setAttribute('data-y', y);
    }

    function reset() {
        largePreview.removeAttribute('data-y');
        largePreview.removeAttribute('style');
        largeImage.style.transform = 'scale(1)';
        largeImage.style.transitionDuration = '1.5s';


        angleScale = {
            angle: 0,
            scale: 1
        }
    }

    window.dragMoveListener = dragMoveListener;

    document.addEventListener("DOMContentLoaded", (ev) => {
        window.addEventListener("resize", (event) => {
            widthActual();
        });
    });
})()
